/* =============================================================
   assets/grout-calculator.js
   Namespace: window.GroutCalculator
   ES5-compatible. No global pollution beyond this namespace.
   ============================================================= */

(function () {
  'use strict';

  /**
   * Pre-select a <option> whose data-handles attribute (comma-separated)
   * contains the given handle. Falls back to the ?product= URL parameter
   * if no handle is passed.
   *
   * @param {HTMLSelectElement} selectEl
   * @param {string} handle - Shopify product handle (may be empty string)
   */
  function preselectProduct(selectEl, handle) {
    var target = (handle || '').trim();

    if (!target) {
      try {
        var params = new URLSearchParams(window.location.search);
        target = (params.get('product') || '').trim();
      } catch (e) {
        target = '';
      }
    }

    if (!target) return;

    var options = selectEl.querySelectorAll('option');
    for (var i = 0; i < options.length; i++) {
      var raw = options[i].getAttribute('data-handles') || '';
      var handles = raw.split(',');
      for (var j = 0; j < handles.length; j++) {
        if (handles[j].trim() === target) {
          selectEl.selectedIndex = i;
          return;
        }
      }
    }
  }

  /**
   * Initialize one calculator instance.
   * @param {Element} container - A .grout-calc root element
   */
  function init(container) {
    if (!container) return;

    var productHandle = container.getAttribute('data-product-handle') || '';

    var selectEl   = container.querySelector('[data-gc="product"]');
    var tileWWholeEl = container.querySelector('[data-gc="tile-w-whole"]');
    var tileWFracEl  = container.querySelector('[data-gc="tile-w-frac"]');
    var tileLWholeEl = container.querySelector('[data-gc="tile-l-whole"]');
    var tileLFracEl  = container.querySelector('[data-gc="tile-l-frac"]');
    var tileTEl      = container.querySelector('[data-gc="tile-t"]');
    var jointEl      = container.querySelector('[data-gc="joint"]');
    var sqftEl     = container.querySelector('[data-gc="sqft"]');
    var errorEl    = container.querySelector('[data-gc="error"]');
    var resultsEl  = container.querySelector('[data-gc="results"]');
    var calcBtn    = container.querySelector('[data-gc="calc-btn"]');

    if (selectEl) {
      preselectProduct(selectEl, productHandle);
    }

    function setError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      if (msg) {
        errorEl.classList.add('grout-calc__error--visible');
      } else {
        errorEl.classList.remove('grout-calc__error--visible');
      }
    }

    function clearResults() {
      if (resultsEl) {
        resultsEl.classList.remove('grout-calc__results--visible');
      }
    }

    function showResults(data) {
      if (!resultsEl) return;

      var covEl      = resultsEl.querySelector('[data-gc="r-cov"]');
      var unitsEl    = resultsEl.querySelector('[data-gc="r-units"]');
      var qtyEl      = resultsEl.querySelector('[data-gc="r-qty"]');
      var unitNameEl = resultsEl.querySelector('[data-gc="r-unit-name"]');
      var textEl     = resultsEl.querySelector('[data-gc="r-text"]');
      var buyBtn     = resultsEl.querySelector('[data-gc="r-buy-btn"]');

      if (covEl)      covEl.textContent      = data.coverageSF.toFixed(2);
      if (unitsEl)    unitsEl.textContent    = data.unitsNeeded.toFixed(2);
      if (qtyEl)      qtyEl.textContent      = data.qty;
      if (unitNameEl) unitNameEl.textContent = data.productName;

      if (textEl) {
        /* Safe string concatenation — no user input reaches innerHTML */
        textEl.innerHTML =
          '<strong>' + data.productGroup + ' - ' + data.productName + '</strong><br>' +
          'Rounded up from ' + data.unitsNeeded.toFixed(2) + ' units.<br>' +
          'Covers up to ' + (data.qty * data.coverageSF).toFixed(0) + ' sq ft.';
      }

      if (buyBtn) buyBtn.href = data.productUrl;

      resultsEl.classList.add('grout-calc__results--visible');
      resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function calculate() {
      if (!selectEl) return;

      var opt          = selectEl.options[selectEl.selectedIndex];
      var cuIn         = parseFloat(opt.value);
      var productUrl   = opt.getAttribute('data-url')   || '#';
      var productName  = opt.getAttribute('data-name')  || '';
      var productGroup = opt.getAttribute('data-group') || '';

      var tw = parseFloat(tileWWholeEl && tileWWholeEl.value ? tileWWholeEl.value : 0) + parseFloat(tileWFracEl ? tileWFracEl.value : 0);
      var tl = parseFloat(tileLWholeEl && tileLWholeEl.value ? tileLWholeEl.value : 0) + parseFloat(tileLFracEl ? tileLFracEl.value : 0);
      var tt = parseFloat(tileTEl ? tileTEl.value : '');
      var jw = parseFloat(jointEl ? jointEl.value : '');
      var sf    = parseFloat(sqftEl  ? sqftEl.value   : '');

      setError('');
      clearResults();

      var missing = [];
      if (!tw) missing.push('Tile width');
      if (!tl) missing.push('Tile length');
      if (!tt) missing.push('Tile thickness');
      if (!jw) missing.push('Grout joint');
      if (!sf || sf <= 0) missing.push('Total area');
      if (missing.length) {
        setError('Please provide a value for: ' + missing.join(', ') + '.');
        return;
      }

      /*
        Standard grout coverage formula:
        groutVol (in³/ft²) = [ jw × tt × (tw + tl) ] / [ (tw + jw) × (tl + jw) ] × 144
        coverageSF = cuIn / groutVol
      */
      var groutVol    = (jw * tt * (tw + tl)) / ((tw + jw) * (tl + jw)) * 144;
      var coverageSF  = cuIn / groutVol;
      var unitsNeeded = sf / coverageSF;
      var qty         = Math.ceil(unitsNeeded);

      showResults({
        coverageSF:   coverageSF,
        unitsNeeded:  unitsNeeded,
        qty:          qty,
        productName:  productName,
        productGroup: productGroup,
        productUrl:   productUrl
      });
    }

    if (calcBtn) {
      calcBtn.addEventListener('click', function () {
        calculate();
      });
    }

    /* Allow Enter key in text/number inputs to trigger calculation */
    var inputs = container.querySelectorAll(
      '[data-gc="tile-w-whole"], [data-gc="tile-l-whole"], [data-gc="sqft"]'
    );
    for (var k = 0; k < inputs.length; k++) {
      inputs[k].addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          calculate();
        }
      });
    }
  }

  /**
   * Auto-initialize all elements marked with data-gc-auto on DOMContentLoaded.
   */
  function autoInit() {
    var containers = document.querySelectorAll('.grout-calc[data-gc-auto]');
    for (var i = 0; i < containers.length; i++) {
      init(containers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInit);
  } else {
    autoInit();
  }

  window.GroutCalculator = { init: init };

})();
